import Vue from 'vue'
import BasicLayout from '@/layout/BasicLayout'
import WebLayout from '@/layout/WebLayout'
import { Message } from 'element-ui'
import VueI18n from 'vue-i18n';
import i18n from './../i18n'
import insIndex from '@/views/inspector/index/index'
import serveBrief from '@/views/web/OurServe/serveBrief'
import uploadFile from '@/views/web/OurServe/file'
Vue.use(VueRouter)
// 用户端路由
const userRouter = {
  path: '/user',
  redirect: '/user/index',
  component: BasicLayout,
  children: [
    {//系统公告
      path: 'index',
      name: 'index',
      label: '我的主页',
      meta: { requireAuth: true },
      component: () => import('../views/user/index/index.vue')
    },
    {
      path: 'orderManage',
      name: 'orderManage',
      label: '订单管理',
      meta: {
        requireAuth: true,
        title: '订单管理'
      },
      component: () => import('../views/user/order/orderIndex.vue')
    },
    {
      path: 'fundManage',
      name: 'fundManage',
      label: '资金管理',
      meta: {
        requireAuth: true,
        title: '资金管理'
      },
      component: () => import('../views/user/reCommend/reCommend.vue')
    },
    {
      path: 'accountManage',
      name: 'accountManage',
      label: '账户设置',
      meta: { requireAuth: true },
      component: () => import('../views/user/accountManage/index.vue'),
    },
    {//推广有礼
      path: 'promotion',
      name: 'promotion',
      label: '推广有礼',
      meta: { requireAuth: true },
      component: () => import('../views/user/Promotion/Promotion.vue'),
    },/* {
      path:'orderManage/orderDetail',
      name:'orderManageOrderDetail',
      label: '订单详情',
      meta: {requireAuth: true},
      component: () => import('../views/user/orderDetail.vue')
    }, */
    {
      path: 'orderManage/editDetail',
      name: 'orderManage/editDetail',
      label: '编辑订单',
      meta: { requireAuth: true },
      component: () => import('../views/user/EditDetail.vue')
    },
    {
      path: 'Mysuppliers',
      name: 'Mysuppliers',
      label: '我的供应商',
      meta: { requireAuth: true },
      component: () => import('../views/user/Mysuppliers.vue')
    },
    {
      path: 'BingMap',
      name: 'BingMap',
      label: 'Bing测试',
      meta: { requireAuth: false },
      component: () => import('../components/BingMap.vue')
    },
  ]
}
// 验货端路由
const InsRouter = {
  path: '/insp',
  redirect: '/insp/sindex',
  component: BasicLayout,
  children: [
    //使用须知
    {
      path: 'instructions',
      name: 'instructions',
      label: '验货须知',
      meta: {
        requireAuth: true
      },
      component: () => import("../views/inspector/index/syxz")
    },
    {//系统公告
      path: 'sindex',
      name: 'sindex',
      label: '我的主页',
      meta: { requireAuth: true },
      component: insIndex,
    },
    {
      path: 'wantOrder',
      name: 'wantOrder',
      label: '我要下单',
      meta: { requireAuth: true},
      component: () => import('../views/inspector/placeOrder/index.vue')
    },
    {
      path: 'orderManage',
      name: 'orderManage',
      label: '订单管理',
      meta: { requireAuth: true },
      component: () => import('../views/inspector/order/orderIndex.vue')
    },
	{
	  path: 'orderHelp',
	  name: 'orderHelp',
	  label: '验货协助',
	  meta: { requireAuth: true },
	  component: () => import('../views/inspector/help/orderIndex.vue')
	},
    {
      path: 'fundManage',
      name: 'fundManage',
      label: '资金管理',
      meta: { requireAuth: true },
      component: () => import('../views/inspector/founManage/reCommend.vue')
    },
    {
      path: 'evaluate',
      name: 'evaluate',
      label: '评价管理',
      meta: { requireAuth: true },
      component: () => import('../views/inspector/evaluationManage/index.vue'),
    },
    {
      path: 'accountManage',
      name: 'accountManage',
      label: '账户设置',
      meta: { requireAuth: true },
      component: () => import('../views/inspector/accountSet/index.vue'),
    },
    {//推广有礼
      path: 'promotion',
      name: 'promotion',
      label: '推广有礼',
      meta: { requireAuth: true },
      component: () => import('../views/inspector/extension/Promotion.vue'),
    },
    { //申请记录
      path: 'applyRecod',
      name: 'applyRecod',
      component: () => import('../views/inspector/index/applyRecod.vue'),
    }, {
      path: 'orderManage/orderDetail',
      name: 'orderManage/orderDetail',
      label: '订单详情',
      meta: { requireAuth: true },
      component: () => import('../views/inspector/orderDetail.vue')
    }
  ]
}
// 网站首页
const webIndex = {
  path: '/index',
  redirect: '/index/index',
  component: WebLayout,
  children: [
    { // 发布悬赏
      path: '/purchase/add',
      label: '发布悬赏',
      name:'addPurchase',
      meta: {
        requireAuth: true // 不需要登录可以访问
      },
      component: () => import('../views/purchase/add.vue')
    },
    {
      path: 'login',
      name: '登陆',
      meta: { requireAuth: false },
      component: () => import('../views/login.vue')
    },
    {
      path: 'register',
      name: '注册',
      meta: { requireAuth: false },
      component: () => import('../views/registerIndex.vue')
    },
    {
      path: 'registerInsp',
      name: '注册验货员',
      meta: { requireAuth: false },
      component: () => import('../views/registerInsp.vue')
    },
    {
      path: 'index',
      name: 'index',
      label: '首页',
      meta: {
        requireAuth: false // 不需要登录可以访问
      },
      // component: () => import('../views/web/Home/index.vue')
      component: () => import('../views/fullpage.vue')
    },
    {
      path: 'wantOrder',
      name: 'wantOrder',
      label: '我要下单',
      meta: { requireAuth: false},
      component: () => import('../views/user/wantOrder/index.vue')
    },{
      path: 'visitOrder',
      name: 'visitOrder',
      label: '游客下单',
      meta: { requireAuth: false},
      component: () => import('../views/user/wantOrder/index.vue')
    },
    {
      path: 'checkOrder',
      name: 'checkOrder',
      label: '验货付款',
      meta: { requireAuth: false },
      component: () => import('../views/user/wantOrder/checkOrder.vue')
    },
    {
      path: 'payTip',
      name: 'payTip',
      label: '验货支付成功提示',
      meta: { requireAuth: false },
      component: () => import('../views/user/wantOrder/payTip.vue')
    },
    {
      path: 'ourServer',
      name: 'ourServer',
      label: '验货服务',
      meta: { requireAuth: false},
      component: serveBrief,
    },{
      path: 'file',
      name: 'file',
      label: '资料下载',
      meta: { requireAuth: false},
      component: uploadFile,
    },
    {
      path: 'search',
      name: 'search',
      label: '地图搜索',
      meta: { requireAuth: false },
      component: () => import('../views/web/Home/search.vue')
    },
    {
      path: 'InspectorInfo',
      name: 'InspectorInfo',
      label: '验货员资料',
      meta: { requireAuth: false },
      component: () => import('../views/web/Home/InspectorInfo.vue')
    },
    {
      path: 'MoreProducts',
      name: 'MoreProducts',
      label: '更多产品',
      meta: { requireAuth: false },
      component: () => import('../views/web/Home/MoreProducts.vue')
    },
    {
      path: 'aboutUs',
      name: 'aboutUs',
      label: '关于平台',
      meta: {
        requireAuth: false // 不需要登录可以访问
      },
      component: () => import('../views/web/AboutUs/index.vue')
    },
    {
      path: 'rechange_tip',
      name: 'rechange_tip',
      label: '支付失败提示',
      meta: {
        requireAuth: false // 不需要登录可以访问
      },
      component: () => import('../components/rechange_tip')
    },

  ]
}

export const routes = [
  userRouter, //用户端路由
  InsRouter, // 验货员路由
  webIndex, //首页路由
  {
    path: '*',
    redirect: '/index'
  },
  {
    path: '/weixinShow',
    component: () => import('../components/QRCode')
  },
  {//游客聊天
    path: '/visitorchat',
    component: () => import('../components/visitorchat.vue')
  },
  {//群组聊天
    path: '/groupchat',
    component: () => import('../components/chat.vue')
  },
  {//群组聊天
    path: '/googleMap',
    component: () => import('../components/GoogleMap')
  },
  {
    path: '/mdata',
    name: 'mdata',
    label: '首页',
    meta: {
      requireAuth: false // 不需要登录可以访问
    },
    component: () => import('../views/mdata.vue')
  }
]
//  console.log(process.env.BASE_URL);
const router = new VueRouter({
  mode: 'history',
 //mode:'hash',//服务器测试 使用
  linkActiveClass: 'isActive',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.path != '/index/index') {
    window.scrollTo(0, 0)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = `${i18n.t('HOME')}`
    // document.title = to.meta.title
  }else{
    document.title = `${i18n.t('HOME')}`
  }
 // if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', `${i18n.t('KEYWORDS_CONTENT')}`)
    document.querySelector('meta[name="description"]').setAttribute('content',  `${i18n.t('KEYWORDS_CONTENT')}`)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  //}
  // console.log("页面" + to.meta.title);
  // 清除缓存
  var now = Date.now();
  var loginTime = +localStorage.getItem("loginTime") || 0;
  if (now - loginTime >= 10 * 60 * 60 * 1000) {
    //超过10小时
    //alert(now - loginTime >= 10 * 60 * 60 * 1000);
    localStorage.removeItem("userInfo");
    localStorage.removeItem("USERToken")
  }
  /*  window.scrollTo(0,0) */
  let isLogin = localStorage.getItem('USERToken') ? true : false
  if (to.meta.requireAuth == true) {
    //已经登录
    if (isLogin) {
      next();
    } else {
      //Message.error("请您先登录");
        let uri = window.location.search.indexOf('?u=')>-1 ? window.location.search : encodeURIComponent(window.location.pathname+window.location.search);
      next({ path: '/index/login', query:{u:uri}})   //下一跳路由需要登录验证，并且还未登录，则路由定向到 登录路由
    }
  } else {
    //没有登录
    // if (to.path != '/login') {
    //   next("/login");
    // }else{
    next();
    // }
  }
});
export default router
